import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useSnackbar } from 'notistack';
import { Typography, Grid, Link, RadioGroup } from '@material-ui/core';
import LaunchIcon from '@material-ui/icons/Launch';
import { useLogout } from '@super-template/axios-keycloak-react-auth-integration/src/api';

import RegistrationNav from './WizardControls';
import { TermCheckbox } from './TermCheckbox';
import messages from 'messages';

const TermsAndConditions = ({
  classes,
  handleNextStep,
  handlePreviousStep,
}) => {
  const [state, setState] = useState({
    acceptTerms: null,
  });
  const { enqueueSnackbar } = useSnackbar();
  const intl = useIntl();
  const logout = useLogout();

  const handleChange = (ev) => {
    setState({ acceptTerms: ev.target.value });
  };

  const handleNext = () => {
    if (state.acceptTerms === 'decline') {
      enqueueSnackbar(intl.formatMessage(messages.registration_interrupted), {
        variant: 'info',
      });
      return logout();
    } else if (state.acceptTerms === 'accept') {
      handleNextStep();
    } else {
      enqueueSnackbar(intl.formatMessage(messages.select_one), {
        variant: 'info',
      });
    }
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-evenly"
      alignItems="center"
    >
      <Grid
        item
        xs={12}
        container
        direction="row"
        justifyContent="space-evenly"
        alignItems="flex-start"
        className={classes.borderContainer}
      >
        <Grid item xs={4} className={classes.borderActive}></Grid>
        <Grid item xs={4} className={classes.border}></Grid>
      </Grid>
      <Grid item md={5} sm={11} xs={11}>
        <Typography variant="subtitle2" className={classes.paragraph}>
          {intl.formatMessage(messages.registration_step_1)}
        </Typography>
        <Typography variant="body2" className={classes.parahraph}>
          {intl.formatMessage(messages.registration_step_1_body)}
        </Typography>
        <Typography>
          <Link
            href="https://www.pirha.fi/sidosryhmaportaalin-kayttoehdot"
            target="_blank"
          >
            <LaunchIcon />
            {intl.formatMessage(messages.registration_step_1_action)}
          </Link>
        </Typography>
      </Grid>
      <Grid item md={5} sm={11} xs={11}>
        <RadioGroup
          onChange={handleChange}
          value={state.acceptTerms}
          name="termsRadioGroup"
        >
          <TermCheckbox
            label={intl.formatMessage(messages.registration_terms_accept)}
            name="acceptTerms"
            value="accept"
          />
          <TermCheckbox
            label={intl.formatMessage(messages.registration_terms_decline)}
            name="declineTerms"
            value="decline"
          />
        </RadioGroup>
      </Grid>
      <RegistrationNav
        handleNext={handleNext}
        handlePrevious={handlePreviousStep}
        previousText={intl.formatMessage(messages.interrupt)}
        nextText={intl.formatMessage(messages.next)}
      />
    </Grid>
  );
};

export default TermsAndConditions;
